// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2-QYP","danger":"Select_danger__1yZdE"};